export const DRAFT_KEY_CREATE = 'seizure-land-inventory-draft'
export const DRAFT_KEY_EDIT_PREFIX = 'seizure-land-inventory-draft-'
export const MAX_FILE_BYTES = 20 * 1024 * 1024
export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp']
export const ALLOWED_FILE_EXT = ['.pdf', '.jpg', '.jpeg', '.png', '.webp']
export const ALLOWED_KML_EXT = ['.kml', '.kmz']
export const TENURE_MUSHAA = 'مشاع'
export const TENURE_MUFRAZ = 'مفرز(سجل عيني)'
export const DEFAULT_DIRECTORATE = 'اسيوط'
export const DEFAULT_GOVERNORATE_ID = 20
export const ZONE_OPTIONS = ['اسيوط', 'ديروط', 'منفلوط']

export const HEADER_AGRICULTURAL_REFORM = 'agricultural_reform'
export const HEADER_PRIVATE_STATE_PROPERTY = 'private_state_property'
export const TAB_MAPS = 'maps'

export const SERVICE_AGRICULTURAL = 109
export const SERVICE_AHKAR = 110

export const DEFAULT_MODULE_TABS = [
  { key: HEADER_AGRICULTURAL_REFORM, title: 'قائمة حصر الاستيلاء(اصلاح زراعي)' },
  { key: HEADER_PRIVATE_STATE_PROPERTY, title: 'املاك الدولة الخاصة' },
  { key: TAB_MAPS, title: 'الخرائط' },
]

export const SERVICE_OPTIONS = [
  { value: SERVICE_AGRICULTURAL, text: 'أراضي زراعية' },
  { value: SERVICE_AHKAR, text: 'الأحكار (المباني)' },
]

export const NORTH_SOUTH_OPTIONS = [
  { value: 'north', text: 'شمال' },
  { value: 'south', text: 'جنوب' },
]

export const EAST_WEST_OPTIONS = [
  { value: 'east', text: 'شرق' },
  { value: 'west', text: 'غرب' },
]

export function serviceLabel(serviceId) {
  const n = Number(serviceId)
  if (n === SERVICE_AHKAR) return 'الأحكار (المباني)'
  if (n === SERVICE_AGRICULTURAL) return 'أراضي زراعية'
  return ''
}

export function normalizeServiceId(value) {
  return Number(value) === SERVICE_AHKAR ? SERVICE_AHKAR : SERVICE_AGRICULTURAL
}

export function currentBranchId() {
  if (typeof localStorage === 'undefined') return null
  const stored = localStorage.getItem('branchId')
  if (stored) return stored
  try {
    const userDataRaw = localStorage.getItem('userData')
    const userData = userDataRaw ? JSON.parse(userDataRaw) : null
    return userData?.branch_id || userData?.branchId || userData?.branch?.id || null
  } catch (e) {
    return null
  }
}

export function emptyTeamMember() {
  return {
    _key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    employee_id: null,
    role: '',
    is_lead: false,
  }
}

export function serializeTeamMembers(rows) {
  return (rows || [])
    .map(row => ({
      employee_id: row.employee_id || row.employee?.id || '',
      role: row.role || '',
      is_lead: !!row.is_lead,
    }))
    .filter(row => row.employee_id)
}

export function mapTeamFromApi(inventory = {}) {
  const rows = inventory.team_members || inventory.team || inventory.work_team || []
  if (Array.isArray(rows) && rows.length) {
    return rows.map((row, index) => {
      const employee = row.employee || (row.full_name || row.name ? row : null)
      const employeeId = row.employee_id || employee?.id || null
      return {
        ...emptyTeamMember(),
        employee_id: employeeId,
        role: row.role || row.pivot?.role || '',
        is_lead: !!(row.is_lead || row.pivot?.is_lead || row.lead),
        employee,
        _key: `team-${employeeId || row.id || index}`,
      }
    })
  }
  const ids = inventory.inspection_teams
  if (Array.isArray(ids) && ids.length) {
    return ids.map((id, index) => ({
      ...emptyTeamMember(),
      employee_id: id,
      is_lead: index === 0,
      _key: `team-${id || index}`,
    }))
  }
  return [emptyTeamMember()]
}

export function emptyMapParcel() {
  return {
    _key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    basin_name: '',
    basin_number: '',
    parcel_number: '',
  }
}

export function emptyMapForm() {
  return {
    north_south: 'south',
    east_west: 'east',
    digit_1: '',
    digit_2: '',
    digit_3: '',
    is_returned: false,
    sheet_file: null,
    returned_tiff: null,
    returned_zip: null,
    parcels: [emptyMapParcel()],
  }
}

export function mapDisplayName(item = {}) {
  if (item.name) return item.name
  const ns = NORTH_SOUTH_OPTIONS.find(o => o.value === item.north_south)?.text || ''
  const ew = EAST_WEST_OPTIONS.find(o => o.value === item.east_west)?.text || ''
  const number = item.map_number || `${item.digit_1 || ''}${item.digit_2 || ''}${item.digit_3 || ''}`
  const quad = `${ns} ${ew}`.trim()
  return [quad, number].filter(Boolean).join(' - ') || '—'
}

export function unwrapTabs(res) {
  const payload = res?.data ?? res
  const list = payload?.data || payload?.tabs || payload
  if (!Array.isArray(list) || !list.length) return DEFAULT_MODULE_TABS.slice()
  const mapped = list
    .map(item => {
      if (!item) return null
      if (typeof item === 'string') return { key: item, title: item }
      const key = item.key || item.header_type || item.slug || item.name
      const title = item.title || item.label || item.name_ar || item.name
      if (!key) return null
      return { key, title: title || key }
    })
    .filter(Boolean)
  const hasMaps = mapped.some(t => t.key === TAB_MAPS)
  if (!hasMaps) mapped.push({ key: TAB_MAPS, title: 'الخرائط' })
  return mapped.length ? mapped : DEFAULT_MODULE_TABS.slice()
}

export const LAND_DATA_KEYS = [
  'land_number', 'block_number', 'basin_name', 'governorate', 'zone', 'center', 'village', 'nahia',
  'area_feddan', 'area_qirat', 'area_sahm', 'tenure_type', 'mushaa_total',
  'mushaa_feddan', 'mushaa_qirat', 'mushaa_sahm', 'new_land_number', 'customer_id',
  'northern_limit', 'eastern_limit', 'southern_limit', 'western_limit',
  'taxpayer_name', 'taxpayer_number', 'initial_seizure_report_date', 'notes',
  'code',
]

export const WIZARD_STEPS = [
  { key: 'shahr', title: 'بيانات الشهر والمستند' },
  { key: 'subject', title: 'الخاضع والقانون' },
  { key: 'admin', title: 'الموقع الإداري' },
  { key: 'lands', title: 'القطع / الأراضي' },
  { key: 'encroachment', title: 'التعدي والاستخدام العام' },
  { key: 'review', title: 'مراجعة وحفظ' },
]

export function emptyLand() {
  return {
    _key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    governorate: '',
    governorate_id: DEFAULT_GOVERNORATE_ID,
    center: '',
    center_id: null,
    village: '',
    village_id: null,
    nahia: '',
    nahia_id: null,
    zone: '',
    basin_name: '',
    code: '',
    usage_type: '',
    usage_type_description: '',
    development_map_62_status: '',
    encroached_area_m2: '',
    unallocated_vacant_area: '',
    reservation_method: '',
    encroacher_data: [],
    block_number: '',
    land_number: '',
    parcel_number: '',
    area_feddan: '',
    area_qirat: '',
    area_sahm: '',
    tenure_type: '',
    mushaa_total: '',
    mushaa_feddan: '',
    mushaa_qirat: '',
    mushaa_sahm: '',
    new_land_number: '',
    mapFile: null,
    mapExisting: null,
    mapMediaId: null,
    kmlFile: null,
    kmlExisting: null,
    kmlMediaId: null,
    newMapFile: null,
    newMapExisting: null,
    newMapMediaId: null,
    northern_limit: '',
    eastern_limit: '',
    southern_limit: '',
    western_limit: '',
    customer_id: null,
    customer: null,
    plot_number: '',
    location_index: null,
    area_fqs: '',
    area_m2: '',
    coordinates: [],
    taxpayer_name: '',
    taxpayer_number: '',
    initial_seizure_report_date: '',
    notes: '',
  }
}

export function parseFqs(value) {
  if (value === null || value === undefined || value === '') {
    return { feddan: '', qirat: '', sahm: '' }
  }
  const parts = String(value).split(/[-/]/).map(part => part.trim())
  return {
    feddan: parts[0] || '',
    qirat: parts[1] || '',
    sahm: parts[2] || '',
  }
}

export function normalizeTenure(value) {
  if (value === TENURE_MUFRAZ || value === 'مفرز') return TENURE_MUFRAZ
  if (value === TENURE_MUSHAA) return TENURE_MUSHAA
  return value || ''
}

export function isMushaa(value) {
  return normalizeTenure(value) === TENURE_MUSHAA
}

export function isMufraz(value) {
  return normalizeTenure(value) === TENURE_MUFRAZ
}

export function landHasData(land) {
  if (!land) return false
  if (land.mapFile instanceof File || land.kmlFile instanceof File || land.newMapFile instanceof File) return true
  if (land.mapExisting || land.kmlExisting || land.newMapExisting) return true
  if (mapCoordinates(land.coordinates).length) return true
  return LAND_DATA_KEYS.some(k => String(land[k] || '').trim() !== '')
}

export function normalizeLand(land = {}) {
  const next = { ...emptyLand(), ...land }
  next.tenure_type = normalizeTenure(land.tenure_type)
  if (!next.mushaa_feddan && !next.mushaa_qirat && !next.mushaa_sahm && next.mushaa_total) {
    const parts = parseFqs(next.mushaa_total)
    next.mushaa_feddan = parts.feddan
    next.mushaa_qirat = parts.qirat
    next.mushaa_sahm = parts.sahm
  }
  next.mapFile = land.mapFile instanceof File ? land.mapFile : null
  next.kmlFile = land.kmlFile instanceof File ? land.kmlFile : null
  next.newMapFile = land.newMapFile instanceof File ? land.newMapFile : null
  next.mapMediaId = land.mapMediaId || land.mapExisting?.id || null
  next.kmlMediaId = land.kmlMediaId || land.kmlExisting?.id || null
  next.newMapMediaId = land.newMapMediaId || land.newMapExisting?.id || null
  next.coordinates = mapCoordinates(land.coordinates)
  next.customer = land.customer || null
  next.encroacher_data = Array.isArray(land.encroacher_data)
    ? land.encroacher_data.map(row => ({ ...emptyEncroacher(), ...row }))
    : []
  return next
}

export function copyAdminFrom(land) {
  const next = emptyLand()
  if (!land) return next
  next.governorate = land.governorate || ''
  next.governorate_id = land.governorate_id || DEFAULT_GOVERNORATE_ID
  next.center = land.center || ''
  next.center_id = land.center_id || null
  next.village = land.village || ''
  next.village_id = land.village_id || null
  next.nahia = land.nahia || ''
  next.nahia_id = land.nahia_id || null
  next.zone = land.zone || ''
  return next
}

export function locationHasKml(land) {
  return !!(land && (
    land.kmlFile instanceof File
    || land.kmlExisting
    || mapCoordinates(land.coordinates).length >= 3
  ))
}

export function locationHasPolygon(land) {
  return mapCoordinates(land && land.coordinates).length >= 3
}

export function emptyEncroacher() {
  return {
    _key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    id: null,
    name: '',
    national_id: '',
    phone: '',
    area_m2: '',
    notes: '',
    service_id: SERVICE_AGRICULTURAL,
    service_label: serviceLabel(SERVICE_AGRICULTURAL),
    project_id: null,
    project_created: false,
  }
}

export function createEmptyForm() {
  return {
    id: null,
    uuid: '',
    shahr_number: '',
    shahr_date: '',
    shahr_year: '',
    directorate: DEFAULT_DIRECTORATE,
    zone: '',
    subject_name: '',
    subject_phone: '',
    applicable_law: '',
    law_year: '',
    taxpayer_name: '',
    taxpayer_number: '',
    initial_seizure_report_date: '',
    affiliated_association: '',
    decision_type: '',
    jurisdiction_authority: '',
    governorate: '',
    governorate_id: DEFAULT_GOVERNORATE_ID,
    center: '',
    center_id: null,
    village: '',
    village_id: null,
    nahia: '',
    nahia_id: null,
    basin_name: '',
    basin_number: '',
    plot_number: '',
    area_fqs: '',
    area_feddan: '',
    area_qirat: '',
    area_sahm: '',
    area_m2: '',
    registered_area_m2: '',
    borders: {
      north: '', south: '', east: '', west: '', description: '',
    },
    land_code: '',
    usage_type: '',
    usage_type_description: '',
    development_map_62_status: '',
    encroached_area_m2: '',
    unallocated_vacant_area: '',
    reservation_method: '',
    notes: '',
    is_created: false,
    project_id: null,
    lands_count: 0,
    encroachments_count: 0,
    header_type: HEADER_AGRICULTURAL_REFORM,
    create_project: false,
    update_if_exists: false,
    project_locations: [emptyLand()],
    encroacher_data: [],
    team_members: [emptyTeamMember()],
    inspection_teams: [],
  }
}

export function formatFqs(feddan, qirat, sahm) {
  const f = String(feddan ?? '').trim()
  const q = String(qirat ?? '').trim()
  const s = String(sahm ?? '').trim()
  if (f === '' && q === '' && s === '') return ''
  return `${f || '0'}-${q || '0'}-${s || '0'}`
}

export function sumRegisteredArea(locations) {
  return (locations || []).reduce((sum, land) => {
    const n = Number(land.area)
    return sum + (Number.isFinite(n) ? n : 0)
  }, 0)
}

function locationNotes(land) {
  const basin = String(land.basin_name || '').trim()
  const extra = String(land.location_notes || '').trim()
  if (basin && extra && extra !== basin) return `${basin} — ${extra}`
  return extra || basin
}

export function mapFirstLandToParent(form) {
  const first = (form.project_locations || []).find(landHasData) || (form.project_locations || [])[0] || null
  const parentLandCode = String((first && first.code) || form.land_code || '').trim()

  return {
    plot_number: first ? (first.land_number || first.plot_number || '') : '',
    basin_name: first ? (first.basin_name || '') : '',
    basin_number: first ? (first.block_number || first.basin_number || '') : '',
    land_code: parentLandCode,
    governorate: first ? (first.governorate || '') : '',
    governorate_id: first ? (first.governorate_id || '') : '',
    center: first ? (first.center || '') : '',
    center_id: first ? (first.center_id || '') : '',
    village: first ? (first.village || first.nahia || '') : '',
    village_id: first ? (first.village_id || first.nahia_id || '') : '',
    nahia: first ? (first.nahia || '') : '',
    area_feddan: first ? (first.area_feddan || '') : '',
    area_qirat: first ? (first.area_qirat || '') : '',
    area_sahm: first ? (first.area_sahm || '') : '',
    area_fqs: first ? formatFqs(first.area_feddan, first.area_qirat, first.area_sahm) : '',
    taxpayer_name: first ? (first.taxpayer_name || '') : '',
    taxpayer_number: first ? (first.taxpayer_number || '') : '',
    initial_seizure_report_date: first ? (first.initial_seizure_report_date || '') : '',
    notes: first ? (first.notes || '') : '',
    borders: first ? {
      north: first.northern_limit || '',
      east: first.eastern_limit || '',
      south: first.southern_limit || '',
      west: first.western_limit || '',
    } : {
      north: '', east: '', south: '', west: '',
    },
  }
}

export function serializeEncroachers(rows) {
  return (rows || [])
    .map(row => {
      const serviceId = normalizeServiceId(row.service_id)
      const payload = {
        name: row.name || '',
        national_id: row.national_id || '',
        phone: row.phone || '',
        area_m2: row.area_m2 === '' || row.area_m2 === null || row.area_m2 === undefined ? '' : row.area_m2,
        notes: row.notes || '',
        service_id: serviceId,
      }
      if (row.id) payload.id = row.id
      return payload
    })
    .filter(row => row.name || row.national_id || row.phone || row.area_m2 || row.notes)
}

export function mapEncroachersFromApi(rows) {
  if (!Array.isArray(rows)) return []
  return rows.map(row => {
    const serviceId = normalizeServiceId(row.service_id)
    return {
      ...emptyEncroacher(),
      id: row.id || null,
      name: row.name || row.encroacher_name || '',
      national_id: row.national_id || '',
      phone: row.phone || '',
      area_m2: row.area_m2 ?? '',
      notes: row.notes || row.description || '',
      service_id: serviceId,
      service_label: row.service_label || serviceLabel(serviceId),
      project_id: row.project_id || row.project?.id || null,
      project_created: !!(row.project_id || row.project?.id || row.project_created),
    }
  })
}

export function landHasEncroachment(land) {
  if (!land) return false
  if (Array.isArray(land.encroachments) && land.encroachments.length) return true
  if (Array.isArray(land.encroacher_data) && land.encroacher_data.length) return true
  return [
    'code', 'land_code', 'usage_type', 'activity', 'usage_type_description', 'development_map_62_status',
    'encroached_area_m2', 'unallocated_vacant_area', 'reservation_method',
  ].some(key => String(land[key] ?? '').trim() !== '')
}

export function hydrateLandEncroachment(form) {
  const lands = form.project_locations || []
  if (!lands.length) return form
  if (lands.some(landHasEncroachment)) return form
  const target = lands.find(locationHasKml) || lands[0]
  if (!target) return form
  target.code = target.code || form.land_code || ''
  target.usage_type = target.usage_type || target.activity || form.usage_type || ''
  target.usage_type_description = target.usage_type_description || form.usage_type_description || ''
  target.development_map_62_status = target.development_map_62_status || form.development_map_62_status || ''
  target.encroached_area_m2 = target.encroached_area_m2 || form.encroached_area_m2 || ''
  target.unallocated_vacant_area = target.unallocated_vacant_area || form.unallocated_vacant_area || ''
  target.reservation_method = target.reservation_method || form.reservation_method || ''
  target.encroacher_data = mapEncroachersFromApi(form.encroacher_data)
  return form
}

export function filledLocations(form) {
  return (form.project_locations || []).filter(landHasData)
}

function locationRemoveFlags(land) {
  const flags = {}
  if (!(land.mapFile instanceof File) && !land.mapExisting && land.mapMediaId) {
    flags.remove_map_file = 1
  }
  if (!(land.kmlFile instanceof File) && !land.kmlExisting && land.kmlMediaId) {
    flags.remove_kml_file = 1
  }
  if (!(land.newMapFile instanceof File) && !land.newMapExisting && land.newMapMediaId) {
    flags.remove_new_map_file = 1
  }
  return flags
}

export function hasMultipartUploads(form, files = []) {
  if ((files || []).some(item => item && item.file instanceof File && !item.existing)) return true
  return filledLocations(form).some(land => (
    land.mapFile instanceof File
    || land.kmlFile instanceof File
    || (isMufraz(land.tenure_type) && land.newMapFile instanceof File)
  ))
}

export function buildPayload(form, options = {}) {
  const parent = mapFirstLandToParent(form)
  const locations = filledLocations(form).map((land, index) => ({
    ...(land.id ? { id: land.id } : {}),
    location_index: land.location_index != null && land.location_index !== '' ? land.location_index : index,
    land_number: land.land_number || land.parcel_number || land.plot_number || '',
    block_number: land.block_number || land.basin_number || '',
    parcel_number: land.parcel_number || land.land_number || land.plot_number || '',
    plot_number: land.plot_number || land.land_number || land.parcel_number || '',
    governorate: land.governorate || '',
    governorate_id: land.governorate_id || '',
    zone: land.zone || form.zone || '',
    center: land.center || '',
    center_id: land.center_id || '',
    village: land.village || land.nahia || '',
    village_id: land.village_id || land.nahia_id || '',
    nahia: land.nahia || land.village || '',
    nahia_id: land.nahia_id || land.village_id || '',
    basin_name: land.basin_name || '',
    basin_number: land.block_number || land.basin_number || '',
    location_notes: land.notes || land.basin_name || '',
    area_feddan: land.area_feddan || '',
    area_qirat: land.area_qirat || '',
    area_sahm: land.area_sahm || '',
    area_fqs: land.area_fqs || formatFqs(land.area_feddan, land.area_qirat, land.area_sahm),
    tenure_type: normalizeTenure(land.tenure_type),
    mushaa_feddan: isMushaa(land.tenure_type) ? (land.mushaa_feddan || '') : '',
    mushaa_qirat: isMushaa(land.tenure_type) ? (land.mushaa_qirat || '') : '',
    mushaa_sahm: isMushaa(land.tenure_type) ? (land.mushaa_sahm || '') : '',
    mushaa_total: isMushaa(land.tenure_type)
      ? formatFqs(land.mushaa_feddan, land.mushaa_qirat, land.mushaa_sahm)
      : '',
    customer_id: land.customer_id || '',
    taxpayer_name: land.taxpayer_name || land.customer?.name || '',
    new_land_number: isMufraz(land.tenure_type) ? (land.new_land_number || '') : '',
    northern_limit: land.northern_limit || '',
    eastern_limit: land.eastern_limit || '',
    southern_limit: land.southern_limit || '',
    western_limit: land.western_limit || '',
    taxpayer_number: land.taxpayer_number || '',
    initial_seizure_report_date: land.initial_seizure_report_date || '',
    notes: land.notes || '',
    code: land.code || '',
    activity: land.usage_type || '',
    usage_type: land.usage_type || '',
    usage_type_description: land.usage_type_description || '',
    development_map_62_status: land.development_map_62_status || '',
    encroached_area_m2: land.encroached_area_m2 || '',
    unallocated_vacant_area: land.unallocated_vacant_area || '',
    reservation_method: land.reservation_method || '',
    encroacher_data: serializeEncroachers(land.encroacher_data),
    ...locationRemoveFlags(land),
  }))

  const source = (form.project_locations || []).find(locationHasKml)
    || filledLocations(form)[0]
    || {}
  const encroachers = filledLocations(form).flatMap(land => serializeEncroachers(land.encroacher_data))
  const removeDocumentIds = (options.removeDocumentIds || form.remove_registration_document_ids || [])
    .map(id => Number(id))
    .filter(id => Number.isInteger(id) && id > 0)

  return {
    shahr_number: form.shahr_number || '',
    shahr_date: yearToDate(form.shahr_date),
    directorate: form.directorate || '',
    zone: form.zone || source.zone || '',
    subject_name: form.subject_name || '',
    subject_phone: form.subject_phone || '',
    applicable_law: form.applicable_law || '',
    law_year: form.law_year === '' || form.law_year == null
      ? ''
      : (Number.isFinite(Number(form.law_year)) ? Number(form.law_year) : form.law_year),
    governorate: parent.governorate || form.governorate || '',
    governorate_id: parent.governorate_id || form.governorate_id || '',
    center: parent.center || form.center || '',
    center_id: parent.center_id || form.center_id || '',
    village: parent.village || form.village || '',
    village_id: parent.village_id || form.village_id || '',
    nahia: parent.nahia || form.nahia || '',
    basin_name: parent.basin_name,
    basin_number: parent.basin_number,
    plot_number: parent.plot_number,
    area_fqs: parent.area_fqs,
    area_feddan: parent.area_feddan,
    area_qirat: parent.area_qirat,
    area_sahm: parent.area_sahm,
    borders: parent.borders,
    taxpayer_name: parent.taxpayer_name,
    taxpayer_number: parent.taxpayer_number,
    initial_seizure_report_date: parent.initial_seizure_report_date,
    notes: parent.notes,
    affiliated_association: form.affiliated_association || '',
    decision_type: form.decision_type || '',
    development_map_62_status: source.development_map_62_status || form.development_map_62_status || '',
    usage_type: source.usage_type || form.usage_type || '',
    usage_type_description: source.usage_type_description || form.usage_type_description || '',
    land_code: source.code || parent.land_code || form.land_code || '',
    jurisdiction_authority: form.jurisdiction_authority || '',
    encroached_area_m2: source.encroached_area_m2 || form.encroached_area_m2 || '',
    encroacher_data: encroachers,
    unallocated_vacant_area: source.unallocated_vacant_area || form.unallocated_vacant_area || '',
    reservation_method: source.reservation_method || form.reservation_method || '',
    registered_area_m2: parent.registered_area_m2 || '',
    project_locations: locations,
    header_type: form.header_type || HEADER_AGRICULTURAL_REFORM,
    team_members: serializeTeamMembers(form.team_members),
    create_project: false,
    update_if_exists: !!form.update_if_exists,
    ...(removeDocumentIds.length ? { remove_registration_document_ids: removeDocumentIds } : {}),
  }
}

function appendFormValue(fd, key, value) {
  if (value === null || value === undefined) {
    fd.append(key, '')
    return
  }
  if (typeof File !== 'undefined' && value instanceof File) {
    fd.append(key, value)
    return
  }
  if (Array.isArray(value)) {
    if (!value.length) {
      return
    }
    value.forEach((item, i) => {
      if (typeof File !== 'undefined' && item instanceof File) {
        fd.append(`${key}[]`, item)
      } else if (item && typeof item === 'object') {
        Object.keys(item).forEach(childKey => {
          appendFormValue(fd, `${key}[${i}][${childKey}]`, item[childKey])
        })
      } else {
        fd.append(`${key}[${i}]`, item ?? '')
      }
    })
    return
  }
  if (typeof value === 'object') {
    Object.keys(value).forEach(childKey => {
      appendFormValue(fd, `${key}[${childKey}]`, value[childKey])
    })
    return
  }
  if (typeof value === 'boolean') {
    fd.append(key, value ? '1' : '0')
    return
  }
  fd.append(key, value)
}

export function buildFormData(form, files = [], options = {}) {
  const fd = new FormData()
  const payload = buildPayload(form, options)
  const removeDocumentIds = payload.remove_registration_document_ids || []
  Object.keys(payload).forEach(key => {
    if (key === 'remove_registration_document_ids') return
    appendFormValue(fd, key, payload[key])
  })
  files.forEach(entry => {
    if (entry && entry.file instanceof File) {
      fd.append('registration_documents[]', entry.file)
    }
  })
  filledLocations(form).forEach((land, i) => {
    if (land.mapFile instanceof File) {
      fd.append(`project_locations[${i}][map_file]`, land.mapFile)
    }
    if (land.kmlFile instanceof File) {
      fd.append(`project_locations[${i}][kml_file]`, land.kmlFile)
    }
    if (isMufraz(land.tenure_type) && land.newMapFile instanceof File) {
      fd.append(`project_locations[${i}][new_map_file]`, land.newMapFile)
    }
  })
  removeDocumentIds.forEach(id => {
    fd.append('remove_registration_document_ids[]', id)
  })
  return fd
}

export function canSaveIdentity(form) {
  const subjectOk = String(form.subject_name || '').trim() !== ''
  if (!subjectOk) return false

  const parent = mapFirstLandToParent(form)
  if (String(parent.land_code || '').trim()) return true

  const gov = String(parent.governorate || '').trim()
  const center = String(parent.center || '').trim()
  const village = String(parent.nahia || parent.village || '').trim()
  const plot = String(parent.plot_number || '').trim()
  return !!(gov && center && village && plot)
}

export function shouldCheckDuplicate(form) {
  const parent = mapFirstLandToParent(form)
  if (String(parent.land_code || '').trim()) return true
  const gov = String(parent.governorate || '').trim()
  const center = String(parent.center || '').trim()
  const village = String(parent.nahia || parent.village || '').trim()
  const plot = String(parent.plot_number || '').trim()
  const shahr = String(form.shahr_number || '').trim()
  return !!(gov && center && village && plot && shahr)
}

export function duplicateCheckBody(form) {
  const parent = mapFirstLandToParent(form)
  return {
    land_code: parent.land_code || '',
    governorate: parent.governorate || '',
    center: parent.center || '',
    village: parent.nahia || parent.village || '',
    plot_number: parent.plot_number || '',
    shahr_number: form.shahr_number || '',
  }
}

export function parseDuplicateResponse(payload, httpStatus) {
  const data = payload?.data ?? payload ?? {}
  const inventory = data.inventory
    || data.matched_inventory
    || data.match
    || data.existing
    || data.record
    || (data.id ? data : null)
  const duplicateFlag = data.duplicate === true
    || data.is_duplicate === true
    || httpStatus === 409
    || !!(inventory && inventory.id)

  if (!duplicateFlag) {
    return { duplicate: false, match_reason: null, inventory: null, raw: data }
  }

  return {
    duplicate: true,
    match_reason: data.match_reason || data.reason || inventory?.match_reason || null,
    inventory,
    raw: data,
  }
}

function isInventoryRecord(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false
  if (obj.inventory && obj.project !== undefined && obj.id == null) return false
  if (obj.id != null && obj.id !== '') return true
  return Array.isArray(obj.project_locations) || Array.isArray(obj.projectLocations) || Array.isArray(obj.parcels)
}

export function inventoryFromResponse(res) {
  return res?.data?.inventory ?? res?.data ?? res
}

export function unwrapInventory(res) {
  const unwrapped = inventoryFromResponse(res)
  if (unwrapped && unwrapped.inventory && isInventoryRecord(unwrapped.inventory) && unwrapped.id == null) {
    return unwrapped.inventory
  }
  if (isInventoryRecord(unwrapped)) return unwrapped
  if (unwrapped && isInventoryRecord(unwrapped.data)) return unwrapped.data
  return unwrapped
}

export function createProjectBody(serviceId) {
  return {
    service_id: normalizeServiceId(serviceId),
    current_branch_id: currentBranchId() || '',
    inspection_teams: [],
  }
}

export function numericInventoryId(value) {
  const n = Number(value)
  return Number.isInteger(n) && n > 0 ? n : null
}

function locationIndexOf(item, fallback) {
  const n = Number(item && item.location_index)
  return Number.isInteger(n) && n >= 0 ? n : fallback
}

export function inventoryLocations(inventory) {
  if (!inventory || typeof inventory !== 'object') return []
  const locArr = Array.isArray(inventory.project_locations)
    ? inventory.project_locations
    : (Array.isArray(inventory.projectLocations) ? inventory.projectLocations : [])
  const parArr = Array.isArray(inventory.parcels) ? inventory.parcels : []
  if (locArr.length) {
    if (!parArr.length) return locArr
    return locArr.map((loc, index) => {
      const locIdx = locationIndexOf(loc, index)
      const match = parArr.find((parcel, pIndex) => {
        if (loc.id && parcel.id && String(loc.id) === String(parcel.id)) return true
        return locationIndexOf(parcel, pIndex) === locIdx
      }) || parArr[index] || {}
      return { ...match, ...loc }
    })
  }
  return parArr
}

export function parcelEncroachments(parcel) {
  if (!parcel) return []
  if (Array.isArray(parcel.encroachments) && parcel.encroachments.length) {
    return mapEncroachersFromApi(parcel.encroachments)
  }
  return mapEncroachersFromApi(parcel.encroacher_data || parcel.encroachers || [])
}

export function inventoryLocationLabel(item) {
  if (!item) return '—'
  const parts = [
    item.governorate,
    item.zone,
    item.center,
    item.village || item.nahia,
    item.basin_name,
    item.block_number || item.basin_number,
    item.land_number || item.parcel_number || item.plot_number,
  ].map(v => String(v || '').trim()).filter(Boolean)
  return parts.length ? parts.join(' — ') : '—'
}

export function canLinkSeizure(item) {
  if (!item) return false
  if (item.can_link_seizure === true) return true
  if (item.can_link_seizure === false) return false
  const lands = landsCount(item)
  const linked = Number(item.linked_parcels_count)
  if (Number.isFinite(linked) && lands > 0) return linked < lands
  const parcels = inventoryLocations(item)
  if (!parcels.length) return false
  return parcels.some(p => !p.linked && !p.cadastral_map_parcel_id && !p.linked_parcel_id)
}

export function encroachmentsCount(item) {
  if (!item) return 0
  if (Number.isFinite(Number(item.encroachments_count))) return Number(item.encroachments_count)
  const parcels = inventoryLocations(item)
  if (parcels.length) {
    return parcels.reduce((sum, parcel) => sum + parcelEncroachments(parcel).length, 0)
  }
  const rows = item.encroacher_data || item.encroachments || []
  return Array.isArray(rows) ? rows.length : 0
}

export function linkedParcelsCount(item) {
  if (!item) return 0
  if (Number.isFinite(Number(item.linked_parcels_count))) return Number(item.linked_parcels_count)
  const parcels = inventoryLocations(item)
  return parcels.filter(p => p.linked || p.cadastral_map_parcel_id || p.linked_parcel_id).length
}

export function unwrapList(res) {
  const payload = res?.data ?? res
  if (Array.isArray(payload)) {
    return { rows: payload, meta: { total: payload.length, per_page: payload.length, current_page: 1 } }
  }
  const rows = payload?.data
  if (Array.isArray(rows)) {
    return {
      rows,
      meta: payload.meta || {
        total: payload.total,
        per_page: payload.per_page,
        current_page: payload.current_page,
      },
    }
  }
  if (Array.isArray(payload?.inventories)) {
    return { rows: payload.inventories, meta: payload.meta || {} }
  }
  if (Array.isArray(payload?.maps)) {
    return { rows: payload.maps, meta: payload.meta || {} }
  }
  return { rows: [], meta: {} }
}

function mediaId(value) {
  const n = Number(value)
  return Number.isInteger(n) && n > 0 ? n : null
}

function mediaSlot(item, fallbackName) {
  if (!item || typeof item !== 'object') return null
  const id = mediaId(item.id)
  const name = item.file_name || item.name || item.original_name || fallbackName
  const url = item.url || item.download_url || item.original_url || item.path || item.full_url || null
  const downloadUrl = item.download_url || url
  if (!id && !url && !item.file_name && !item.name && !item.original_name) return null
  return { id, name: name || fallbackName, url, download_url: downloadUrl }
}

export function normalizeArabicName(value) {
  return String(value || '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/\s+/g, ' ')
    .trim()
}

function pickCoordNumber(point, keys) {
  for (let i = 0; i < keys.length; i += 1) {
    const n = Number(point[keys[i]])
    if (Number.isFinite(n)) return n
  }
  return null
}

export function mapCoordinates(raw) {
  if (!raw) return []
  let list = raw
  if (!Array.isArray(raw)) {
    if (Array.isArray(raw.coordinates)) list = raw.coordinates
    else if (Array.isArray(raw.points)) list = raw.points
    else if (raw.geometry && Array.isArray(raw.geometry.coordinates)) {
      const geom = raw.geometry.coordinates
      list = Array.isArray(geom[0]) && Array.isArray(geom[0][0]) ? geom[0] : geom
    } else return []
  }
  return list.map(point => {
    if (point == null) return null
    let lat = null
    let lng = null
    if (Array.isArray(point) && point.length >= 2) {
      const a = Number(point[0])
      const b = Number(point[1])
      if (!Number.isFinite(a) || !Number.isFinite(b)) return null
      if (Math.abs(a) > 90 || (Math.abs(a) > 40 && Math.abs(b) <= 90)) {
        lng = a
        lat = b
      } else {
        lat = a
        lng = b
      }
    } else if (typeof point === 'object') {
      lat = pickCoordNumber(point, ['latitude', 'lat', 'y', 'coord_y'])
      lng = pickCoordNumber(point, ['longitude', 'lng', 'lon', 'long', 'x', 'coord_x'])
    }
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
    return { latitude: lat, longitude: lng }
  }).filter(Boolean)
}

export function coordinatesToLatLngs(raw) {
  return mapCoordinates(raw).map(point => [point.latitude, point.longitude])
}

export function locationMediaList(item = {}) {
  const map = mediaSlot(item.map_file || item.map, 'الخريطة')
  const kml = mediaSlot(item.kml_file || item.kml, 'KML')
  const newMap = mediaSlot(item.new_map_file || item.new_map || item.new_cadastral_map, 'زمام جديد')
  return [
    map ? { key: 'map', label: 'خريطة', ...map } : null,
    kml ? { key: 'kml', label: 'KML', ...kml } : null,
    newMap ? { key: 'new_map', label: 'زمام جديد', ...newMap } : null,
  ].filter(Boolean)
}

function landFromApi(item = {}, fallback = {}) {
  const land = emptyLand()
  const mapMedia = mediaSlot(item.map_file || item.map || item.map_document, 'الخريطة')
  const kmlMedia = mediaSlot(item.kml_file || item.kml, 'KML')
  const newMapMedia = mediaSlot(item.new_map_file || item.new_map || item.new_cadastral_map, 'خريطة الزمام الجديد')
  const fqs = parseFqs(item.area_fqs)
  const mushaa = parseFqs(item.mushaa_total)
  const customer = item.customer && typeof item.customer === 'object' ? item.customer : null
  const encroachers = item.encroachments || item.encroacher_data || item.encroachers || []
  return {
    ...land,
    id: item.id || null,
    location_index: item.location_index != null ? item.location_index : null,
    linked: !!(item.linked || item.cadastral_map_parcel_id || item.linked_parcel_id),
    cadastral_map_id: item.cadastral_map_id || null,
    cadastral_map_parcel_id: item.cadastral_map_parcel_id || item.linked_parcel_id || null,
    governorate: item.governorate || fallback.governorate || '',
    governorate_id: item.governorate_id || fallback.governorate_id || null,
    center: item.center || fallback.center || '',
    center_id: item.center_id || fallback.center_id || null,
    village: item.village || fallback.village || '',
    village_id: item.village_id || fallback.village_id || null,
    nahia: item.nahia || item.district || fallback.nahia || '',
    nahia_id: item.nahia_id || item.district_id || fallback.nahia_id || null,
    zone: item.zone || fallback.zone || '',
    land_number: item.land_number || item.parcel_number || item.plot_number || '',
    plot_number: item.plot_number || item.land_number || item.parcel_number || '',
    block_number: item.block_number || item.basin_number || '',
    parcel_number: item.parcel_number || item.land_number || item.plot_number || '',
    basin_name: item.basin_name || '',
    area_fqs: item.area_fqs || '',
    area_feddan: item.area_feddan || fqs.feddan,
    area_qirat: item.area_qirat || fqs.qirat,
    area_sahm: item.area_sahm || fqs.sahm,
    area_m2: item.area_m2 ?? '',
    tenure_type: normalizeTenure(item.tenure_type),
    mushaa_total: item.mushaa_total || '',
    mushaa_feddan: item.mushaa_feddan || mushaa.feddan,
    mushaa_qirat: item.mushaa_qirat || mushaa.qirat,
    mushaa_sahm: item.mushaa_sahm || mushaa.sahm,
    new_land_number: item.new_land_number || '',
    customer_id: item.customer_id || customer?.id || null,
    customer,
    northern_limit: item.northern_limit || item.borders?.north || '',
    eastern_limit: item.eastern_limit || item.borders?.east || '',
    southern_limit: item.southern_limit || item.borders?.south || '',
    western_limit: item.western_limit || item.borders?.west || '',
    taxpayer_name: item.taxpayer_name || customer?.name || customer?.name_ar || '',
    taxpayer_number: item.taxpayer_number || '',
    initial_seizure_report_date: item.initial_seizure_report_date || '',
    notes: item.notes || item.location_notes || '',
    code: item.code || item.land_code || fallback.land_code || '',
    usage_type: item.usage_type || item.activity || '',
    usage_type_description: item.usage_type_description || '',
    development_map_62_status: item.development_map_62_status || '',
    encroached_area_m2: item.encroached_area_m2 ?? '',
    unallocated_vacant_area: item.unallocated_vacant_area || '',
    reservation_method: item.reservation_method || '',
    encroacher_data: mapEncroachersFromApi(encroachers),
    coordinates: mapCoordinates(item.coordinates),
    mapMediaId: mapMedia ? mapMedia.id : null,
    kmlMediaId: kmlMedia ? kmlMedia.id : null,
    newMapMediaId: newMapMedia ? newMapMedia.id : null,
    mapExisting: mapMedia,
    kmlExisting: kmlMedia,
    newMapExisting: newMapMedia,
  }
}

export function inventoryToForm(inventory = {}) {
  const record = inventoryFromResponse(inventory) || {}
  const form = createEmptyForm()
  const locations = inventoryLocations(record)

  Object.keys(form).forEach(key => {
    if (key === 'project_locations' || key === 'encroacher_data' || key === 'create_project' || key === 'update_if_exists' || key === 'team_members') return
    if (record[key] !== undefined && record[key] !== null) {
      form[key] = record[key]
    }
  })
  form.shahr_date = toYearValue(record.shahr_year) || toYearValue(record.shahr_date) || ''
  form.shahr_year = record.shahr_year != null && record.shahr_year !== ''
    ? record.shahr_year
    : (toYearValue(record.shahr_date) || '')

  form.create_project = false
  form.update_if_exists = false
  form.header_type = record.header_type || form.header_type || HEADER_AGRICULTURAL_REFORM
  form.team_members = mapTeamFromApi(record)
  form.governorate_id = record.governorate_id || null
  form.center_id = record.center_id || null
  form.village_id = record.village_id || null
  form.nahia = record.nahia || record.village || ''
  if (record.borders && typeof record.borders === 'object') {
    form.borders = {
      north: record.borders.north || '',
      south: record.borders.south || '',
      east: record.borders.east || '',
      west: record.borders.west || '',
      description: record.borders.description || '',
    }
  }

  const headerFallback = {
    governorate: form.governorate,
    governorate_id: form.governorate_id,
    center: form.center,
    center_id: form.center_id,
    village: form.village,
    village_id: form.village_id,
    nahia: form.nahia,
    nahia_id: form.nahia_id,
    zone: form.zone,
    land_code: form.land_code,
  }

  form.project_locations = locations.length
    ? locations.map(item => landFromApi(item, headerFallback))
    : []

  if (!form.project_locations.length && (record.plot_number || record.basin_name || record.basin_number)) {
    const land = emptyLand()
    land.land_number = record.plot_number || ''
    land.plot_number = record.plot_number || ''
    land.basin_name = record.basin_name || ''
    land.block_number = record.basin_number || ''
    land.governorate = record.governorate || ''
    land.governorate_id = record.governorate_id || null
    land.center = record.center || ''
    land.center_id = record.center_id || null
    land.village = record.village || ''
    land.village_id = record.village_id || null
    land.nahia = record.nahia || record.village || ''
    land.area_feddan = record.area_feddan || parseFqs(record.area_fqs).feddan
    land.area_qirat = record.area_qirat || parseFqs(record.area_fqs).qirat
    land.area_sahm = record.area_sahm || parseFqs(record.area_fqs).sahm
    land.northern_limit = record.borders?.north || ''
    land.eastern_limit = record.borders?.east || ''
    land.southern_limit = record.borders?.south || ''
    land.western_limit = record.borders?.west || ''
    land.taxpayer_name = record.taxpayer_name || ''
    land.taxpayer_number = record.taxpayer_number || ''
    land.initial_seizure_report_date = record.initial_seizure_report_date || ''
    land.notes = record.notes || record.location_notes || ''
    land.code = record.land_code || ''
    form.project_locations = [land]
  }

  if (!form.project_locations.length) {
    form.project_locations = [emptyLand()]
  }

  const encroachers = record.encroacher_data || record.encroachers || []
  form.encroacher_data = mapEncroachersFromApi(encroachers)
  form.project_locations.forEach((land, index) => {
    if (!String(land.zone || '').trim()) land.zone = form.zone || ''
    if (!land.governorate_id) land.governorate_id = form.governorate_id
    if (!land.governorate) land.governorate = form.governorate
    if (!land.center_id) land.center_id = form.center_id
    if (!land.center) land.center = form.center
    if (!land.village_id) land.village_id = form.village_id
    if (!land.village) land.village = form.village || form.nahia
    if (!land.nahia) land.nahia = form.nahia || land.village
    if (land.location_index == null) land.location_index = index
    if (!land.code) land.code = form.land_code || ''
  })
  hydrateLandEncroachment(form)

  return form
}

export function existingAttachments(inventory = {}) {
  const record = inventoryFromResponse(inventory) || inventory || {}
  const list = record.registration_documents
    || record.attachments
    || record.media
    || record.documents
    || []
  if (!Array.isArray(list)) return []
  return list.map((item, index) => {
    const slot = mediaSlot(item, `ملف ${index + 1}`) || {}
    return {
      id: slot.id || mediaId(item.id),
      name: slot.name || `ملف ${index + 1}`,
      url: slot.url || null,
      download_url: slot.download_url || slot.url || null,
      mime: item.mime_type || item.mime || '',
      existing: true,
    }
  }).filter(item => item.id || item.url || item.name)
}

export function draftKey(editId) {
  return editId ? `${DRAFT_KEY_EDIT_PREFIX}${editId}` : DRAFT_KEY_CREATE
}

export function saveDraft(editId, form, stepIndex) {
  try {
    const safeForm = JSON.parse(JSON.stringify({
      ...form,
      project_locations: (form.project_locations || []).map(land => ({
        ...land,
        mapFile: null,
        kmlFile: null,
        newMapFile: null,
      })),
    }))
    sessionStorage.setItem(draftKey(editId), JSON.stringify({
      stepIndex,
      form: safeForm,
      savedAt: Date.now(),
    }))
  } catch (e) {
    // quota / private mode
  }
}

export function loadDraft(editId) {
  try {
    const raw = sessionStorage.getItem(draftKey(editId))
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function clearDraft(editId) {
  try {
    sessionStorage.removeItem(draftKey(editId))
  } catch (e) {
    // ignore
  }
}

export function optionLabel(option) {
  if (!option) return ''
  if (typeof option === 'string') return option
  return option.name_ar || option.name_local || option.name || option.title || ''
}

export function findNamedOption(options, id, name) {
  const list = Array.isArray(options) ? options : []
  if (id != null && id !== '') {
    const byId = list.find(item => String(item && item.id) === String(id))
    if (byId) return byId
  }
  const wanted = normalizeArabicName(name)
  if (!wanted) return null
  const byName = list.find(item => normalizeArabicName(optionLabel(item)) === wanted)
  return byName || name
}

export function toYearValue(value) {
  if (value === null || value === undefined || value === '') return ''
  const str = String(value).trim()
  const match = str.match(/\d{4}/)
  return match ? match[0] : ''
}

export function yearToDate(value) {
  const year = toYearValue(value)
  return year ? `${year}-01-01` : ''
}

export function formatDateDisplay(value) {
  if (!value) return '—'
  const str = String(value)
  return str.length >= 10 ? str.slice(0, 10) : str
}

export function formatYearDisplay(value) {
  return toYearValue(value) || '—'
}

export function formatShahrYear(inventory) {
  if (!inventory) return '—'
  return toYearValue(inventory.shahr_year) || toYearValue(inventory.shahr_date) || '—'
}

export function landsCount(item) {
  if (!item) return 0
  if (Number.isFinite(Number(item.lands_count))) return Number(item.lands_count)
  if (Number.isFinite(Number(item.project_locations_count))) return Number(item.project_locations_count)
  if (Number.isFinite(Number(item.parcels_count))) return Number(item.parcels_count)
  return inventoryLocations(item).length
}

export function fileIsAllowed(file) {
  if (!file) return false
  if (file.size > MAX_FILE_BYTES) return false
  const name = (file.name || '').toLowerCase()
  const extOk = ALLOWED_FILE_EXT.some(ext => name.endsWith(ext))
  const typeOk = !file.type || ALLOWED_FILE_TYPES.includes(file.type) || file.type === 'image/jpg'
  return extOk && typeOk
}

export function fileIsAllowedKml(file) {
  if (!file) return false
  if (file.size > MAX_FILE_BYTES) return false
  const name = (file.name || '').toLowerCase()
  return ALLOWED_KML_EXT.some(ext => name.endsWith(ext))
}
